import { forwardRef, InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        // 44px e 16px sotto sm: sotto i 16px iOS zooma il viewport al focus.
        "flex h-11 w-full rounded-md border border-white/10 bg-input/40 px-3 py-1 text-base shadow-sm",
        "sm:h-9 sm:text-sm",
        "transition-[border-color,box-shadow,background-color] duration-fast ease-palazzo",
        "placeholder:text-muted-foreground hover:border-white/20",
        // §8: anello oro sempre visibile al focus, mai outline:none nudo.
        "focus-visible:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        // Nasconde la X nativa di type="search": la nostra vive nella Toolbar.
        "[&::-webkit-search-cancel-button]:appearance-none",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
